import {
  isPending,
  getEventsSuccess,
  getSingleEventSuccess,
  createEventSuccess,
  updateEventSuccess,
  deleteEventSuccess,
  addGalleryImagesSuccess,
  eventFail,
} from "./EventSlice";
import eventAPI from "../../apis/eventApi";

// Helpers
const pickArray = (res) =>
  Array.isArray(res)
    ? res
    : Array.isArray(res?.data)
    ? res.data
    : Array.isArray(res?.data?.events)
    ? res.data.events
    : [];

const pickObject = (res) =>
  res && res._id
    ? res
    : res?.data && res?.data._id
    ? res.data
    : res?.data?.event && res?.data?.event._id
    ? res.data.event
    : null;

// ✅ Create Event
export const createEventAction = (eventData) => async (dispatch) => {
  dispatch(isPending());
  try {
    const res = await eventAPI.createNewEvent(eventData);
    const obj = pickObject(res);
    if (obj) {
      dispatch(createEventSuccess(obj));
      return obj;
    }
    return dispatch(eventFail(res));
  } catch (error) {
    dispatch(eventFail(error));
    return error;
  }
};

// ✅ Get all events
export const fetchEventsAction = () => async (dispatch) => {
  dispatch(isPending());
  try {
    const res = await eventAPI.fetchEvents();
    const arr = pickArray(res);
    if (arr.length >= 0) {
      dispatch(getEventsSuccess(arr));
      return arr;
    }
    return dispatch(eventFail(res));
  } catch (error) {
    dispatch(eventFail(error));
    return error;
  }
};

// ✅ Get single event
export const fetchSingleEventAction = (_id) => async (dispatch) => {
  dispatch(isPending());
  try {
    const res = await eventAPI.fetchEvents(_id);
    const obj = pickObject(res);
    if (obj) {
      dispatch(getSingleEventSuccess(obj));
      return obj;
    }
    return dispatch(eventFail(res));
  } catch (error) {
    dispatch(eventFail(error));
    return error;
  }
};

// ✅ Update event
export const updateEventAction = (_id, eventData) => async (dispatch) => {
  dispatch(isPending());
  try {
    const res = await eventAPI.updateEvent(_id, eventData);
    const obj = pickObject(res);
    if (obj) {
      dispatch(updateEventSuccess(obj));
      return obj;
    }
    return dispatch(eventFail(res));
  } catch (error) {
    dispatch(eventFail(error));
    return error;
  }
};

// ✅ Delete event
export const deleteEventAction = (_id) => async (dispatch) => {
  dispatch(isPending());
  try {
    await eventAPI.deleteEvent(_id);
    dispatch(deleteEventSuccess(_id));
    return _id;
  } catch (error) {
    dispatch(eventFail(error));
    return error;
  }
};

// ✅ Add gallery images after event ended
export const addGalleryImagesAction =
  (_id, gallery, extendedDesc) => async (dispatch) => {
    dispatch(isPending());
    try {
      const res = await eventAPI.addGalleryImages(_id, {
        images: gallery,
        extendedDesc,
      });
      const obj = pickObject(res);
      if (obj) {
        dispatch(addGalleryImagesSuccess(obj));
        return obj;
      }
      return dispatch(eventFail(res));
    } catch (error) {
      dispatch(eventFail(error));
      return error;
    }
  };
